import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';

const MaltaPricingCards = ({ pricingData }) => {
  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Simple, Transparent Pricing
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Everything you need to get started with Buddy
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-3">
          {pricingData.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg ${
                plan.featured ? 'ring-2 ring-advisor-900' : ''
              }`}
            >
              {plan.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="inline-flex items-center px-4 py-1 rounded-full text-sm font-medium bg-advisor-900 text-white">
                    Most Popular
                  </span>
                </div>
              )}
              
              <div className="p-8">
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900">
                    {plan.title}
                  </h3>
                  <p className="mt-4 text-sm text-gray-500">
                    {plan.description}
                  </p>
                </div>

                <div className="mt-8">
                  <div className="flex items-baseline justify-center">
                    <span className="text-5xl font-extrabold text-gray-900">
                      €{plan.price}
                    </span>
                    <span className="ml-1 text-xl font-semibold text-gray-500">
                      {plan.period}
                    </span>
                  </div>
                  {plan.note && (
                    <p className="mt-2 text-sm text-gray-500 text-center">
                      {plan.note}
                    </p>
                  )}
                </div>

                <ul className="mt-8 space-y-4">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <CheckIcon
                        className="flex-shrink-0 h-5 w-5 text-advisor-900 mt-0.5"
                        aria-hidden="true"
                      />
                      <span className="ml-3 text-sm text-gray-700">
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                {plan.ctaText && (
                  <div className="mt-8">
                    <a
                      href={plan.ctaLink}
                      className={`block w-full text-center px-6 py-3 border rounded-md text-base font-medium transition duration-150 ease-in-out ${
                        plan.featured
                          ? 'bg-advisor-900 text-white hover:bg-advisor-700'
                          : 'bg-white text-advisor-900 border-advisor-900 hover:bg-advisor-50'
                      }`}
                    >
                      {plan.ctaText}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            All monthly plans include ongoing support and updates
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaltaPricingCards;
